import { Box, Typography, Chip, Avatar, Grid, Button } from '@mui/material';
import { Building2, MapPin, Hash, CheckCircle, Clock } from 'lucide-react';
import { tokens } from '@/theme/tokens';
import dayjs from 'dayjs';

export function SchoolProfileHeader({ school, onEdit }) {
  if (!school) return null;

  return (
    <Box
      sx={{
        bgcolor: tokens.colors.card,
        borderRadius: 3,
        overflow: 'hidden',
        border: `1px solid ${tokens.colors.border}`,
        mb: 3
      }}
    >
      {/* Banner */}
      <Box 
        sx={{ 
          height: 120, 
          background: `linear-gradient(135deg, ${tokens.colors.primary.main} 0%, ${tokens.colors.primary.dark} 100%)`,
          position: 'relative'
        }}
      />
      
      {/* Profile Info */}
      <Box sx={{ p: 3, pt: 0, position: 'relative' }}>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, alignItems: 'flex-start' }}>
          
          {/* Logo */}
          <Avatar
            src={school.logo}
            variant="rounded"
            sx={{
              width: 100,
              height: 100,
              mt: -5,
              border: '4px solid white',
              bgcolor: tokens.colors.primary[50],
              color: tokens.colors.primary.main,
              fontWeight: 700,
              fontSize: '2rem',
              boxShadow: tokens.shadows.card
            }}
          >
            {school.name.charAt(0)}
          </Avatar>

          {/* Details */}
          <Box sx={{ flex: 1, mt: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 2 }}>
              <Box>
                <Typography variant="h4" fontWeight={800} color="text.primary">
                  {school.name}
                </Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mt: 1, color: tokens.colors.text.secondary }}>
                  <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <Building2 size={16} /> {school.code} • {school.schoolType}
                  </Typography>
                  <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <MapPin size={16} /> {school.city}, {school.state}
                  </Typography>
                  <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <Hash size={16} /> Reg: {school.registrationNumber}
                  </Typography>
                </Box>
              </Box>

              <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                <Chip 
                  icon={school.status === 'active' ? <CheckCircle size={14} /> : <Clock size={14} />}
                  label={school.status} 
                  color={school.status === 'active' ? 'success' : 'error'}
                  sx={{ textTransform: 'capitalize', fontWeight: 600 }}
                />
                <Button variant="outlined" size="small" onClick={onEdit}>
                  Edit Profile
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
